module.exports = __webpack_public_path__ + "media/images/iconSocialShare__okGreen-f857e57b27a49198f3dcf3daa77b3c2c.png";